import moment from "moment-timezone";

/**
 * A helper function to convert a number to a time
 * @param time - quanity of time in minutes
 * return an object with the direction and the time formatted in Days, Hours, & Minutes
 */
export const dateTimeFormat = (time: number): any => {
  if (time === 0) {
    return null;
  }
  const direction = time > 0 ? "forward" : "back";
  const absTime = Math.abs(time);
  //change timeshift format...
  const days = Math.abs(Math.trunc(moment.duration(absTime, "minutes").as("days")));
  const hours = Math.abs(Math.trunc(moment.duration(absTime - days * 24 * 60, "minutes").as("hours")));
  const minutes = Math.abs(Math.trunc(moment.duration(absTime - days * 24 * 60 - hours * 60, "minutes").as("minutes")));

  const format = (timeValue: number, timeUnit: string): string => {
    if (timeValue === 0) {
      return "";
    }
    switch (timeUnit) {
      case "minute":
        return timeValue > 1 ? `${timeValue} minutes` : `${timeValue} minute`;
      case "hour":
        if (minutes === 0) {
          return timeValue > 1 ? `${timeValue} hours` : `${timeValue} hour`;
        } else {
          return timeValue > 1 ? `${timeValue} hours and` : `${timeValue} hour and`;
        }
      case "day":
        if (hours === 0 && minutes === 0) {
          return timeValue > 1 ? `${timeValue} days` : `${timeValue} day`;
        } else {
          return timeValue > 1 ? `${timeValue} days and` : `${timeValue} day and`;
        }
      default:
        return "";
    }
  };

  return {
    time: {
      day: days === 0 ? "" : format(days, "day"),
      hour: hours === 0 ? "" : format(hours, "hour"),
      minute: minutes === 0 ? "" : format(minutes, "minute"),
    },
    direction: direction,
  };
};
